const { isEmpty } = require('lodash');

const ShelfProductDetailService = function ShelfProductDetailService(Restangular, $rootScope, breakpointsService) {
    this._api = Restangular.one('product');
    this.breakpointsService = breakpointsService;

    // We invalidate when the trolley updates because product detail
    // objects contain information about quantity in trolley.
    $rootScope.$on('trolley:update', () => {
        this.invalidate();
    });
};

let detailsCache = {};

ShelfProductDetailService.prototype.getProductDetail = function (productStockcode, aisle, category, validateUrl, storeNo) {
    const key = `${productStockcode}_${isEmpty(storeNo) ? 'online' : storeNo}`;
    if (!(key in detailsCache)) {
        detailsCache[key] = this._api.one('detail', productStockcode).get({
            aisle, category, validateUrl, isMobile: this.breakpointsService.isInSmallFormat, storeNo,
        });
    }

    return detailsCache[key];
};

ShelfProductDetailService.prototype.getGeolocationProductStoreDetail = function (productStockcode, latitude, longitude, max, includeInStockStoreOnly) {
    return this._api.one(`${productStockcode}/Stores`).get({
        Latitude: latitude,
        Longitude: longitude,
        Max: max || 5,
        IncludeInStockStoreOnly: includeInStockStoreOnly || false,
    });
};

ShelfProductDetailService.prototype.getPostcodeProductStoreDetail = function (productStockcode, postcode, max, includeInStockStoreOnly) {
    return this._api.one(`${productStockcode}/Stores`).get({ Postcode: postcode, Max: max || 5, IncludeInStockStoreOnly: includeInStockStoreOnly || false });
};

ShelfProductDetailService.prototype.invalidate = function () {
    detailsCache = {};
};

module.exports = ShelfProductDetailService;



// WEBPACK FOOTER //
// ./src/shop/shelfproduct/shelfproduct-detail.service.js